module.exports = __webpack_public_path__ + "static/media/edu-room-img--3.86429e48.svg";